import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Paper, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import Cookies from 'js-cookie';
import CommandCenterDashboard from './CommandCenterDashboard';
import AutomationScripts from './AutomationScripts';
import Subscriptions from './Subscriptions';
import Configurations from './Configurations';
import SystemHealth from './SystemHealth';
import UserManagement from './UserManagement';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const WhatsappBusinessAdminDashboard = () => {
  const [value, setValue] = useState(0);
  const { userRole } = useAuth();
  const navigate = useNavigate();
  const userRoleFromCookie = Cookies.get('userRole');

  useEffect(() => {
    // Check if user has ;ADMIN#VI295 role
    const isAdmin = userRole === ';ADMIN#VI295' || userRoleFromCookie === ';ADMIN#VI295' || 
                    userRole === 'ADMIN#VI295' || userRoleFromCookie === 'ADMIN#VI295';
    if (!isAdmin) {
      navigate('/');
    }
  }, [userRole, userRoleFromCookie, navigate]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isAdmin = userRole === ';ADMIN#VI295' || userRoleFromCookie === ';ADMIN#VI295' || 
                  userRole === 'ADMIN#VI295' || userRoleFromCookie === 'ADMIN#VI295';

  if (!isAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Access Denied: Only ;ADMIN#VI295 users can access this dashboard.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', pt: 3 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        WhatsApp Business Admin Dashboard
      </Typography>

      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="admin dashboard tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Dashboard Metrics" />
            <Tab label="User Management" />
            <Tab label="Automation Scripts" />
            <Tab label="Subscriptions" />
            <Tab label="Configurations" />
            <Tab label="System Health" />
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <CommandCenterDashboard />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <UserManagement />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <AutomationScripts />
        </TabPanel>

        <TabPanel value={value} index={3}>
          <Subscriptions />
        </TabPanel>

        <TabPanel value={value} index={4}>
          <Configurations />
        </TabPanel>

        <TabPanel value={value} index={5}>
          <SystemHealth />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default WhatsappBusinessAdminDashboard;

